import type { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';

import { ErrorSubdomain } from '../../../constants';

import { ServerSideError } from './server-side-error';

export class NotFoundError extends ServerSideError {
  constructor(message: string) {
    super(message, 'Not Found Error');
  }

  public getServerSidePropsResult(
    context: GetServerSidePropsContext
  ): GetServerSidePropsResult<any> {
    return this.getRedirectServerSidePropsResult(
      context,
      ErrorSubdomain.NotFoundSubdomain
    );
  }
}
